import React, { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'

import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/faChevronLeft'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export interface IReturnLinkProps {
  to: string
  onClick?: React.MouseEventHandler<any> | any
}

export const ReturnLink: React.FC<PropsWithChildren<IReturnLinkProps>> = ({
  to,
  children,
}) => (
  <p className="flex box-border m-0">
    <strong className="box-border m-0 mr-2">
      <FontAwesomeIcon icon={faChevronLeft} />
    </strong>
    <Link to={to} className="text-actionable font-body">
      {children}
    </Link>
  </p>
)
